export const STORAGE_KEYS = {
  authToken: "authToken",
  staffId: "staffId",
  staffEmail: "staffEmail",
  name: "name",
  gender: "gender",
  contact_number: "contact_number",
  companyId: "companyId",
  companyName: "companyName",
  acceptedTerms: "acceptedTerms",
  cartDiagnosticIds: "cartDiagnosticIds",
};

export const SESSION_KEYS = {
  staff: "staff",
  companyInfo: "companyInfo",
  sessionExpired: "sessionExpired",
};

export const getStaffId = () => localStorage.getItem(STORAGE_KEYS.staffId);
export const getAuthToken = () => localStorage.getItem(STORAGE_KEYS.authToken);
export const getUserId = () => getStaffId();
export const getCompanyId = () => localStorage.getItem(STORAGE_KEYS.companyId);
export const getGender = () => localStorage.getItem(STORAGE_KEYS.gender);
export const getStaffName = () => localStorage.getItem(STORAGE_KEYS.name);

export const saveLoginSession = (staff, companyInfo, token) => {
  if (staff.termsAndConditionsAccepted) {
    localStorage.setItem(STORAGE_KEYS.acceptedTerms, "true");
  }

  if (token) {
    localStorage.setItem(STORAGE_KEYS.authToken, token);
  }

  localStorage.setItem(STORAGE_KEYS.staffId, staff._id);
  localStorage.setItem(STORAGE_KEYS.name, staff.name);
  if (staff.email) {
    localStorage.setItem(STORAGE_KEYS.staffEmail, staff.email);
    localStorage.setItem("staffEmail", staff.email);
  }
  if (staff.name) localStorage.setItem("staffName", staff.name);
  if (staff.contact_number) localStorage.setItem("staffPhone", staff.contact_number);
  localStorage.setItem(STORAGE_KEYS.gender, staff.gender);
  if (staff.contact_number) {
    localStorage.setItem(STORAGE_KEYS.contact_number, staff.contact_number);
  }

  const companyIdToStore = staff.companyId || companyInfo?.companyId;
  if (companyIdToStore) {
    localStorage.setItem(STORAGE_KEYS.companyId, companyIdToStore);
  }

  if (companyInfo?.companyName) {
    localStorage.setItem(STORAGE_KEYS.companyName, companyInfo.companyName);
  }

  sessionStorage.setItem(SESSION_KEYS.staff, JSON.stringify(staff));
  if (companyInfo) {
    sessionStorage.setItem(SESSION_KEYS.companyInfo, JSON.stringify(companyInfo));
  }
};

export const clearSession = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const markSessionExpired = () => {
  sessionStorage.setItem(SESSION_KEYS.sessionExpired, "1");
};

export const consumeSessionExpired = () => {
  const expired = sessionStorage.getItem(SESSION_KEYS.sessionExpired) === "1";
  if (expired) sessionStorage.removeItem(SESSION_KEYS.sessionExpired);
  return expired;
};

export const getContactNumber = (entity) => {
  if (!entity) return localStorage.getItem(STORAGE_KEYS.contact_number) || "";
  return entity.mobileNumber || entity.contact_number || "";
};
